import { ClientType } from '../apollo'
import { types } from '../types'

import {
  createOnePlace,
  findManyPlace,
  updateOnePlace,
  deleteOnePlace,
} from '@dinosband/bv-main-schema/dist/client-gql'

export async function createPlace (client: ClientType, data: types.PlaceCreateInput): Promise<types.Place | undefined> {
  try {
    const result = await client.mutate({
      mutation: createOnePlace,
      variables: {
        data,
      } as types.MutationCreateOnePlaceArgs,
    })
    return result.data.createOnePlace
  } catch (e) {
  }
}

export async function readPlaces (client: ClientType, where: types.PlaceWhereInput): Promise<types.Place[] | undefined> {
  try {
    const result = await client.query({
      query: findManyPlace,
      variables: {
        where,
      } as types.QueryFindManyPlaceArgs,
    })
    return result.data.findManyPlace
  } catch (e) {
  }
}

export async function updatePlace (client: ClientType, id: number, data: types.PlaceUpdateInput): Promise<types.Place | undefined> {
  try {
    const result = await client.mutate({
      mutation: updateOnePlace,
      variables: {
        where: { id },
        data,
      } as types.MutationUpdateOnePlaceArgs,
    })
    return result.data.updateOnePlace
  } catch (e) {
  }
}

export async function deletePlace (client: ClientType, id: number): Promise<types.Place | undefined> {
  try {
    const result = await client.mutate({
      mutation: deleteOnePlace,
      variables: {
        where: { id },
      } as types.MutationDeleteOnePlaceArgs,
    })
    return result.data.deleteOnePlace
  } catch (e) {
  }
}